import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(dynamic)/country/[slug]/CountryLandingPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
